<template>
  <div>
    <h1 class="section__title">Order Finished</h1>    
  </div>
  
</template>

<script>
export default {
  name: 'OrderFinished',
  components: {
  }
}
</script>

<!-- Add "s
    CenteredButtoncoped" attribute to limit CSS to this component only -->
